import { FC } from "react";
import { Grid } from "antd";
import dayjs from "dayjs";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { CalendarIcon } from "src/assets/Icons";
import { useTranslation } from "react-i18next";
import CheckInComponentWeb from "./layouts/CheckInComponent.web";

const CheckInSelectComponent = withConditionalComponent(CheckInComponentWeb, CheckInComponentWeb);

const CheckInComponent: FC<{ errorFields: string[] }> = ({ errorFields }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const name = "checkin";
  const hasError = errorFields.includes(name);

  const fieldProps = {
    name,
    icon: CalendarIcon,
    label: t("Hotels.common.checkIn"),
    hasError,
    disabledDate: (d: dayjs.Dayjs) => d.isBefore(dayjs(), "day"),
    className: "flex-5 h-15! border-none! focus-within:outline-none! focus-within:ring-0! w-full font-semibold",
  };

  return <CheckInSelectComponent trigger={isLargeScreen} props={fieldProps} />;
};

export default CheckInComponent;
